import { CardMatriculate } from '@/components/molecules/Admin/Cards/CardMatriculate'
import { drawerCreators } from '@/store/ducks/drawer'
import { useAppDispatch } from '@/store/hooks'
import { CohortsModel } from '@models'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation } from 'swiper/modules'
import trailsService from '@/services/trailsService'
import Icon from '@/components/atoms/Icon'

interface CohortCard {
	id: number
	name: string
	'type-course': string
	total_classes: number
	produto: string
	categoria: string
	produto_nome: string
	nome_card: string
	capa_card?: string
	descricao?: string
	sobre_curso?: string
	carga_horaria?: string
	foto_professor?: string
	nome_professor?: string
	sobre_professor?: string
	turma?: {
		id: number
		curso_id: number
		empresa_id: number
		status: string
	}
}

export function TrailsCourses() {
	const dispatch = useAppDispatch()

	const { data: matriculates } = trailsService.getMatriculate()

	const handleDrawerInfo = (courseInfo: CohortsModel.CohortCard) => {
		const sobreCursoArray = courseInfo?.sobre_curso
			?.split('\n')
			.map((paragrafo) => paragrafo.trim())
			.filter((paragrafo) => paragrafo.length > 0)

		dispatch(
			drawerCreators.openDrawer({
				drawerInfo: {
					curso_id: courseInfo.id,
					'type-course': courseInfo['type-course'],
					turma: courseInfo.turma,
					name_course: courseInfo.nome_card,
					description_course: courseInfo.descricao,
					duration: courseInfo.carga_horaria,
					foto_professor: courseInfo.foto_professor,
					name_teacher: courseInfo.nome_professor,
					description_teacher: courseInfo.sobre_professor,
					about_course: sobreCursoArray,
					units: sobreCursoArray,
				},
			})
		)
	}

	const filteredCoursesByProduct: Array<{
		product_name: string
		product: string
		courses: Array<CohortCard>
	}> =
		matriculates?.map((matriculateCourse) => {
			return {
				product_name: matriculateCourse.nome,
				product: matriculateCourse.nome,
				courses: (matriculateCourse.available_courses as any[]).map(
					(course: any) => {
						return {
							...course,
							'name-card': course['name-card'],
							'type-course': course['type-course'],
							curso_id: course.curso_id,
							turma: course.turma,
							categoria: course.categoria,
						} as CohortsModel.CohortCard
					}
				),
			}
		}) ?? []

	return (
		<>
			{filteredCoursesByProduct
				?.filter((product) => product.courses.length > 0)
				?.map((product, key) => {
					return (
						<div className='mt-12 flex flex-col gap-10' key={key}>
							<div className='flex flex-col gap-6'>
								<div className='flex items-center gap-6'>
									<div className='flex py-1 px-2 border border-dashed items-center gap-3 shadow max-w-max border-[#6B47ED] rounded-lg'>
										<Icon name='trail-type' width='16px' height='16px' />
										<p className='text-white'>Trilha</p>
									</div>
									<p className='text-white text-3xl font-semibold'>
										{product.product_name}
									</p>
								</div>
								<div className='relative overflow-visible w-full'>
									{!filteredCoursesByProduct?.length ? (
										<div className='w-full py-3 px-4 flex items-center max-w-max bg-[#191122] border border-dashed border-white/10 rounded-xl'>
											<p className='text-base text-white font-medium'>
												Em breve adicionaremos novos cursos
											</p>
										</div>
									) : (
										<Swiper
											modules={[Pagination, Navigation]}
											slidesPerView='auto'
											spaceBetween={15}
											slidesPerGroup={1}
											centeredSlides={false}
											pagination={{
												clickable: false,
												dynamicBullets: false,
												el: null,
											}}
											autoHeight={true}
											watchSlidesProgress={true}
											slideToClickedSlide={true}
											grabCursor={true}
											breakpoints={{
												768: {
													slidesPerView:
														product.courses.length > 2
															? 2
															: product.courses.length,
												},
												1024: {
													slidesPerView:
														product.courses.length > 2
															? 3
															: product.courses.length,
												},
												1200: {
													slidesPerView:
														product.courses.length > 4
															? 4
															: product.courses.length,
												},
											}}
											navigation={{
												nextEl: `.swiper-button-next-courses-${key}`,
												prevEl: `.swiper-button-prev-courses-${key}`,
											}}
											className='z-0 h-full min-h-[396px] w-full !overflow-visible'
										>
											{product?.courses?.map((course, key) => (
												<SwiperSlide key={key} className='max-w-[320px]'>
													<CardMatriculate
														onClick={() => handleDrawerInfo(course)}
														course={course}
													/>
												</SwiperSlide>
											))}
										</Swiper>
									)}
								</div>
							</div>
						</div>
					)
				})}
		</>
	)
}
